import { useMutation } from '@tanstack/react-query';

import { request } from '~/services/common';

import { CatalogRoom, StopsellExtractionResult } from '~/types/stopsell';

interface ExtractStopsellsInput {
  file: File;
  catalogRooms?: Array<CatalogRoom>;
}

export function useExtractStopsellDates() {
  return useMutation({
    mutationFn: async ({ file, catalogRooms = [] }: ExtractStopsellsInput): Promise<StopsellExtractionResult> => {
      const formData = new FormData();
      formData.append('file', file);
      if (catalogRooms.length > 0) {
        formData.append('roomTypes', JSON.stringify(catalogRooms));
      }

      return request(`${window.configs.API_HOST}/api/ai-hotel/stopsell/extract`, {
        method: 'POST',
        body: formData,
      });
    },
  });
}
